import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EventSummary from './EventSummary';
import { Box, Divider, Alert, AlertTitle, Link } from '@mui/material';
import { useTicketsSelected, useFan2Fan } from '@/store';
import TicketsSelector from '../tickets/TicketsSelector';
import useEventStatus from '@/contexts/event/useEventStatus';
import MsciBanner from '@/sections/msi/MsciBanner';
import MsiPreSale from '@/sections/msi/MsiPreSale';
import useEventContext from '@/contexts/event/useEventContext';
import Fan2FanTickets from '@/sections/secondary-market/Fan2FanTickets';
import useEventAlerts from '@/hooks/checkout/useEventAlerts';
import EventAlert from '../EventAlert';
import Fan2FanRedirectDialog from '@/components/dialogs/Fan2FanRedirectDialog';
import { useCustomLinksActions } from '@/store';
import RenderIf from '@/components/RenderIf';

export default function EventHome({ onReadMore, onTicketCategorySelected, hasFan2Fan }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const { hasTickets } = useTicketsSelected();
  const { eventStatus } = useEventStatus();
  const { alert } = useEventAlerts(eventStatus);
  const {
    customLink: { linkStatus },
  } = useCustomLinksActions();
  const { link, open, setOpen, setShowFan2Fan } = useFan2Fan();

  const { event } = useEventContext();

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'scroll',
      }}
    >
      <Box
        sx={{
          mr: '24px',
          ml: '24px',
          mb: 2,
        }}
      >
        <EventSummary onReadMore={onReadMore} />
      </Box>

      <Box
        sx={{
          ml: '24px',
          mr: '24px',
        }}
      >
        <Divider />
      </Box>

      <Box
        sx={{
          mr: '24px',
          ml: '24px',
        }}
      >
        <MsciBanner />
        {eventStatus === 'pre-sale' && <MsiPreSale />}
        {(linkStatus === 'active' || !linkStatus) &&
          eventStatus === 'active' && (
            <TicketsSelector
              onTicketCategorySelected={onTicketCategorySelected}
              hasFan2Fan={event?.secondary_market?.has}
            />
          )}
        {event?.secondary_market?.has && eventStatus === 'active' && (
          <Fan2FanTickets
            link={event?.secondary_market?.link}
            setShowFan2Fan={setShowFan2Fan}
          />
        )}
        {alert && (
          <EventAlert
            status={eventStatus}
            title={t(alert.title)}
            message={t(alert.message)}
            hasLink={alert.link}
          />
        )}
      </Box>
      {show && hasTickets && (
        <Box
          sx={{
            height: '77px',
            width: '100%',
          }}
        ></Box>
      )}
      <Fan2FanRedirectDialog
        open={open}
        title="¿Quieres continuar a Fan a Fan?"
        text="Serás redirigido a Fan a Fan, nuestro espacio donde puedes adquirir boletos de otros asistentes de forma segura."
        acceptLabel="Continuar a Fan a Fan"
        backLabel="Quedarme en Boletia"
        onConfirm={() => window.open(link, '_blank')}
        onCancel={() => setOpen(false)}
      />
    </Box>
  );
}
